const article = {
	slug: "bijli-aane-wali-hai-ai-in-india",
	title: "Bijli Aane Wali Hai: What AI in India Taught Me",
	date: "August 2025",
	updated: null,
	description: "Two vignettes from a trip to India, a mom meeting Gemini in Marathi and a barber brainstorming with ChatGPT, show that AI's real strength is practical accessibility, not flawless sophistication.",
	keywords: ["AI accessibility", "India", "localization", "generative AI"],
	tldr: "The true measure of AI adoption is not technical sophistication but its ability to integrate into everyday life. The future of AI is about who it can serve.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, August 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `Since landing in India a couple of days ago, I have been impressed and humbled by tech's lower barrier to entry to help handle real-world scenarios touching wide slices of society.

## Mom meets Gemini

Yesterday, I introduced my mom to Gemini on her new phone. She was instantly intrigued. She dove into conversations from the local weather and packing for an upcoming trip, to exploring solutions for her health concerns and navigating challenging emotional situations.

What made it click unexpectedly was Gemini's default Marathi option. I saw the power of localization and how language-specific support enables genuinely real-life conversations.

These moments are exactly why I am so drawn towards Generative AI's potential.

## A $2 haircut and a business problem

In the afternoon I went for a luxurious $2 haircut with a champi massage. ;) Those who know, they know!

The new owner, Mr. Sajid, was struggling with inconsistent clientele after a change in ownership. He mentioned how his old shop in another city had a more consistent clientele from a specific segment of society, making it easier to serve them and gain their patronage.

As happens at the Indian barber shops, we had some wide ranging small talks which led to using ChatGPT to brainstorm strategies for attracting more customers of different demographics. We included prompts for tailored service packages for different personas.

This wasn't about complex algorithms or market research; it was about using publicly available Gen AI as a pragmatic brainstorming partner to solve a tangible business problem.

## Functional beats flawless

Both of these experiences reveal something often missed by AI skeptics who (for now) focus solely on short-term imperfections.

We aren't always striving for a flawless, every-time solution. We are seeking a functional solution that works and delivers value. Period.

Whether it's enabling a non-tech-savvy individual to find daily utility or empowering a small business owner to strategize growth, AI's true strength lies in its practical application when molded to diverse needs.

For us Tech leaders, chasing the latest in Agentic AI space, these examples are a reminder that the true measure of AI adoption isn't just technical sophistication, but whether it fits into everyday life.

I admit, there's a powerful symbolism here, but for the first time in so many years, the Swades 'Bijli' scene hits home. The scene is a powerful depiction of how fundamental infrastructure and technology can spark hope and progress in communities. It doesn't feel exaggerated anymore.

The future of AI isn't just about what it can do, but who it can serve.`,
};

export default article;
